import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import { useEffect } from 'react';

interface IProps {
  children?: any;
  refDialog?: (ref: DialogComponent) => void;
  showDialog: boolean;
  setShowDialog: (cond: boolean) => void;
  header?: string;
  isFullScreen?: boolean;
  buttons?: Array<ButtonPropsModel>;
  width?: string | number;
  height?: string | number;
  hideDoneButton: boolean;
  content?: any;
}
let dialog: DialogComponent = new DialogComponent({});
export default function GlobalDialog({
  children,
  refDialog,
  setShowDialog,
  showDialog,
  header,
  isFullScreen,
  buttons,
  height,
  width,
  hideDoneButton,
  content,
}: IProps) {
  let buttonsOrder: ButtonPropsModel[] = [
    { buttonModel: { content: 'Done' }, click: () => setShowDialog(false) },
  ];
  if (hideDoneButton) {
    buttonsOrder = [];
  }
  if (buttons) {
    buttonsOrder = [...buttonsOrder, ...buttons];
  }
  useEffect(() => {
    if (showDialog) {
      dialog.show(isFullScreen);
    }
    return () => {};
  }, [showDialog]);

  return (
    <div>
      <DialogComponent
        isModal={true}
        id='defaultdialog'
        created={() => {
          if (refDialog) refDialog(dialog);
        }}
        showCloseIcon={true}
        visible={showDialog}
        width={width}
        header={header}
        buttons={buttonsOrder}
        open={() => {
          setShowDialog(true);
        }}
        close={() => {
          setShowDialog(false);
        }}
        height={height}
        ref={(el: DialogComponent) => (dialog = el)}
        statelessTemplates={['content']}
        content={content}
      >
        {children && children}
      </DialogComponent>
    </div>
  );
}
